import { notFound } from "next/navigation";
import { Heading, Spinner, Text, Switch } from "ui-components";

import { makeToast } from "@/src/components/Toast/Toast";
import {
  useUserGetProfile,
  useUserUpdateUserSettings,
} from "@/src/hooks/api/generated";

export default function MyNotificationSettings(): JSX.Element {
  const { data, isLoading, refetch } = useUserGetProfile();
  const { mutate: updateSettings } = useUserUpdateUserSettings();

  function handleChange(type: string, isSelected: boolean): void {
    updateSettings(
      {
        data: {
          is_notify_new_connection:
            type === "is_notify_new_connection" ? isSelected : undefined,
          is_notify_profile_visit:
            type === "is_notify_profile_visit" ? isSelected : undefined,
        },
      },
      {
        onSuccess: () => {
          refetch();
          makeToast({
            title: "Settings updated successfully.",
            intent: "success",
          });
        },
        onError: () => {
          makeToast({
            title: "Something went wrong.",
            intent: "danger",
          });
        },
      }
    );
  }

  if (isLoading) {
    return (
      <div className="flex justify-center mt-10">
        <Spinner size="lg" intent="brand-primary" />
      </div>
    );
  }

  if (!data) {
    return notFound();
  }

  return (
    <div className="w-full flex flex-col gap-y-20">
      <div className="flex flex-col items-center gap-y-5">
        <Heading variant="h3">Notify me about new connections</Heading>
        <div className="w-[597px] text-center">
          <Text>
            Choose if you want to be notified when you receive a request to
            connect.
          </Text>
        </div>
        <Switch
          isSelected={data.userSetting.is_notify_new_connection}
          onChange={(isSelected) =>
            handleChange("is_notify_new_connection", isSelected)
          }
        />
      </div>
      <div className="flex flex-col items-center gap-y-5">
        <Heading variant="h3">Notify me about visits to my profile</Heading>
        <div className="w-[597px] text-center">
          <Text>
            Choose if you want to be notified when a member visits your profile.
          </Text>
        </div>
        <Switch
          isSelected={data.userSetting.is_notify_profile_visit}
          onChange={(isSelected) =>
            handleChange("is_notify_profile_visit", isSelected)
          }
        />
      </div>
    </div>
  );
}
